/**
 * The "Fields in Your File" dropdown cell of the map-fields step (`MapFields.tsx`), with its
 * "Required" message. Despite the file name, it holds no table config.
 */
import React from "react";
import { Typography } from "@ryerson/frontend.typography";
import { Flex, FlexItem } from "@ryerson/frontend.layout";
import { useApplication } from "@ryerson/frontend.application";
import { Dropdown } from "@ryerson/frontend.form-controls";
import { FileMapping } from "./BulkUpload.model";

type DropdownUserFieldProps = {
	/** Theme colour for the message. */
	error: string;
	handleDropdownSelection: (newValue: string, fileField: FileMapping) => void;
	/** The translated "Required" text. */
	isMissingRequiredData: string;
	/** True once the customer has tried to continue with a required field unmapped. */
	_isMissingRequiredData: boolean;
	mappedFileFields: {
		value: string;
		display: string;
	}[];
	rowData: FileMapping;
};

/**
 * Dropdown of the file's headers for one Ryerson field. Shown invalid, with "Required" below,
 * only for a required field left unmapped after the customer tried to continue.
 */
export const DropdownUserField: React.FC<DropdownUserFieldProps> = ({
	error,
	handleDropdownSelection,
	isMissingRequiredData,
	_isMissingRequiredData,
	mappedFileFields,
	rowData,
}) => {
	const {
		localization: { language },
	} = useApplication();
	return (
		<Flex direction="column">
			<Dropdown
				value={rowData.userColumn}
				options={mappedFileFields}
				onChange={(e: string) => {
					handleDropdownSelection(e, rowData);
				}}
				language={language}
				isValid={
					!(_isMissingRequiredData && rowData.required && !rowData.userColumn) ||
					!rowData.required
				}
			/>
			{_isMissingRequiredData && rowData.required && !rowData.userColumn && (
				<FlexItem
					css={{
						marginTop: -5,
					}}
				>
					<Typography size="sm" color={error}>
						{isMissingRequiredData}
					</Typography>
				</FlexItem>
			)}
		</Flex>
	);
};
